import {Component, EventEmitter, HostListener, inject, Input, OnInit, Output} from "@angular/core";
import {MatDialog} from '@angular/material/dialog';

@Component({
  selector: 'app-modal-header',
  templateUrl: './modal-header.component.html',
  styleUrls: ['./modal-header.component.scss']
})
export class ModalHeaderComponent implements OnInit {

  @Input() title: string;
  @Input() showCoverPhoto = true;
  @Input() passwordChanged: boolean;

  @Output() closeDialog = new EventEmitter<any>()

  dialog = inject(MatDialog);

  ngOnInit(): void {
  }

  @HostListener('document:keydown.escape', ['$event'])
  onKeydownHandler(event: KeyboardEvent) {
    this.closeDialog.emit()
    this.dialog.closeAll();
  }
}
